import { Text } from "@chakra-ui/react";

export const SalesCannotCreateInvoiceEMECeFError = () => {
  return (
    <Text>
      La création de la vente sur la plateforme e-MECeF a généré une erreur
    </Text>
  );
};
